<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import {Link} from 'svelte-routing'
    import Pagination from 'src/components/cabinet/#common/pagination/Pagination.svelte.js'
    import {getNftByFilter, marketplaceTransactions} from 'src/components/main/#services/marketplace'
    import Alert from 'src/components/cabinet/#common/alert/Alert.svelte'
    import learnMore from 'src/components/main/#assets/learn-more.svg'

    let marketplaceContainer
    let currentPage = 0
    let perPage = 32

    $: currentPage, filter()

    function filter() {
        marketplaceTransactions.send({ data: {
            "page": currentPage + 1,
            perPage
        }})
        window.scrollTo(0, marketplaceContainer?.offsetTop)
    }

    function getDate(date) {
        date = new Date(date)
        let year = date.toLocaleString("default", {year: "numeric"})
        let month = date.toLocaleString("default", {month: "2-digit"})
        let day = date.toLocaleString("default", {day: "2-digit"})
        return year+"-"+month+"-"+day
    }
</script>

<svelte:head>
    <title>Marketplace Activity</title>
    <meta name="description" content=""/>
</svelte:head>

<MainLayout>
    <svelte:fragment slot="content">
        <section class="catalog" bind:this={marketplaceContainer}>
            <div class="container">
                <div class="user-info">
                    <Link to="marketplace" class="back">
                        <img src="{learnMore}" alt="">
                        <span class="d-md-none">Back</span>
                        <span class="d-none d-md-inline-block">To marketplace</span>
                    </Link>
                </div>
                <Alert />
                <div class="table-responsive" bind:this={marketplaceContainer}>
                    <div class="history-table">
                        <div class="history-table-header">
                            <div>Seller</div>
                            <div>Buyer</div>
                            <div>Type</div>
                            <div>Amount</div>
                            <div>Date</div>
                        </div>
                        <div class="history-table-body">
                            {#if !$marketplaceTransactions.hasValue && $marketplaceTransactions.loading}
                                <div class="color-white text-center">Loading...</div>
                            {:else if !$marketplaceTransactions.hasValue && $marketplaceTransactions.error }
                                <div class="color-white text-center">Something went wrong</div>
                            {:else if $marketplaceTransactions.value}
                                {#each $marketplaceTransactions?.value?.data as {sallerUserId, sallerNickname, buyerUserId, buyerNickname, type, itemPrice, productId, currency, purchaseDate}}
                                    <div class="history-table-row">
                                        <div>
                                            <Link to="marketplace/{sallerUserId}">
                                                {sallerNickname.replace(/#([^#]+)$/, '')}
                                            </Link>
                                        </div>
                                        <div>
                                            <Link to="marketplace/{buyerUserId}">
                                                {buyerNickname.replace(/#([^#]+)$/, '')}
                                            </Link>
                                        </div>
                                        <div class="type">
                                            {#if productId}
                                                <Link to="nft/{productId}">
                                                    {type === 'lootbox' ? 'egg' : type}
                                                </Link>
                                            {:else}
                                                {type === 'lootbox' ? 'egg' : type}
                                            {/if}
                                        </div>
                                        <div>{itemPrice} {currency}</div>
                                        <div>{getDate(purchaseDate).toLocaleString()}</div>
                                    </div>
                                {:else}
                                    <div class="no-data">No data yet</div>
                                {/each}
                            {/if}
                        </div>
                    </div>
                </div>
                {#if $marketplaceTransactions.value}
                    <div class="text-center">
                        <Pagination
                            bind:currentPage={currentPage}
                            totalCount={$marketplaceTransactions?.value?.totalCount}
                            {perPage}
                            disabled={!$marketplaceTransactions.hasValue && $marketplaceTransactions.loading}
                        />
                    </div>
                {/if}
            </div>
        </section>
    </svelte:fragment>
</MainLayout>

<style>
    .catalog {
        padding-top: 5px;
        margin-top: 110px;
    }

    .type {
        text-transform: capitalize;
    }

    .history-table {
        margin: 10px auto 15px;
    }

    .history-table-header {
        display: flex;
        width: 100%;
        background: #cad5e0;
        border-radius: 8px 8px 0 0;
    }

    .history-table-header > div {
        width: 20%;
        padding: 10px 30px;
        background: #CAD5E0;
        color: #272C33;
        font-size: 16px;
        line-height: 20px;
        font-weight: 600;
        white-space: nowrap;
    }

    .history-table-header > div:first-child {
        border-radius: 8px 0 0 0;
    }

    .history-table-header > div:last-child {
        border-radius: 0 8px 0 0;
    }

    .history-table-row {
        border: 1px solid #CAD5E0;
        border-bottom: 0;
        border-radius: 0;
        display: flex;
        width: 100%;
    }

    .history-table-row:last-child {
        border-bottom: 1px solid #CAD5E0;
        border-radius: 0 0 8px 8px;
    }

    .history-table-row > div {
        width: 20%;
        padding: 10px 30px;
        font-size: 15px;
        line-height: 20px;
        font-weight: 500;
        display: flex;
        align-items: center;
        color: white;
        white-space: nowrap;
    }

    .history-table-row :global(a) {
        color: white;
        text-decoration: none;
        text-overflow: ellipsis;
        overflow: hidden;
        transition: .15s;
    }

    .history-table-row :global(a:hover) {
        color: #fb7844;
    }

    .history-column :global(.pagination) {
        justify-content: center;
    }

    .user-info :global(.back) {
        color: white;
        font-size: 20px;
        font-family: 'Anton', sans-serif;
        margin: 50px 0;
        display: table;
        text-decoration: none;
        text-transform: uppercase;
    }

    .user-info :global(.back img) {
        margin-right: 10px;
        transform: rotate(-90deg);
        transition: .25s;
    }

    .user-info :global(.back:hover img) {
        transform: rotate(-135deg);
    }

    .text-center :global(.pagination) {
        justify-content: center;
    }

    @media(max-width: 767px) {
        .catalog {
            padding-top: 1px;
            margin-top: 62px;
        }

        .history-table-row > div {
            padding: 8px 15px;
            font-size: 14px;
        }

        .history-table {
            width: 800px;
            margin-top: 0;
        }

        .user-info :global(.back) {
            margin: 30px 0;
        }
    }
</style>
